"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledResizeStackedCTA = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyledResizeStackedCTA = exports.StyledResizeStackedCTA = _styledComponents["default"].div.attrs({
  className: 'fuse-utils-resize-stacked-ctas'
}).withConfig({
  displayName: "styled-resize-stacked-cta__StyledResizeStackedCTA",
  componentId: "sc-166z5c-0"
})(["display:flex;flex-wrap:wrap;gap:var(--spacing-global-space5);&.fuse-utils-resize-stacked-ctas__ctas--stacked{flex-direction:column;gap:var(--spacing-global-space3);width:fit-content;}.fuse-utils-resize-stacked-ctas__primary-cta--stacked,.fuse-utils-resize-stacked-ctas__secondary-cta--stacked{width:100%;}"]);
var _default = exports["default"] = StyledResizeStackedCTA;